import { render, staticRenderFns } from "./PremiumInvoiceCreate.vue?vue&type=template&id=2f20d294"
import script from "./PremiumInvoiceCreate.vue?vue&type=script&lang=js"
export * from "./PremiumInvoiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports